import { gql } from '@apollo/client';

export const GET_SEARCH_KEY = gql`
    query getSearchKey {
        getSearchKey {
            token
        }
    }
`;
